import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { openseaApiKey } from 'utils/config';

interface OpenSeaUserInfo {
  user?: {
    username?: string;
  };
  address: string;
  profile_img_url: string;
}

const OpenseaName = ({ address }: { address?: string }) => {
  const [userInfo, setUserInfo] = useState<OpenSeaUserInfo | null>(null);

  const fetchOpenseaUser = useCallback(
    async (address: string) => {
      const response = await axios.get(`https://api.opensea.io/api/v1/account/${address}`, {
        headers: {
          'X-API-KEY': openseaApiKey,
        },
      });
      if (response.status === 200) {
        let { data }: any = response.data;
        setUserInfo(data);
      }
    },
    [setUserInfo]
  );

  // fetch user data from opensea
  useEffect(() => {
    if (address) {
      fetchOpenseaUser(address);
    }
  }, [address, fetchOpenseaUser]);

  return userInfo?.user?.username ? (
    <a
      href={`https://opensea.io/accounts/${userInfo.user.username}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'white' }}
    >
      {userInfo.user.username}
    </a>
  ) : (
    <span>{address}</span>
  );
};

export default OpenseaName;
